/*
* @Author: TT
* @Date:   2019-04-29 14:31:38
* @Last Modified by:   TT
* @Last Modified time: 2019-12-11 10:12:52
*/


/**
 * [要设置的全局访问的state对象，用于各个组件间的通信]
 * @type {Object}
 */
const state = {
    username       :0,
    userid         :null,
    usertype       :null,
    lastlogin_time :null,
    permission_list:null,
    grade_list     :null,
    school_name    :null,
    logo           :require("@/assets/img/logo.png"),
    banner         :require("@/assets/img/banner.png"),
};

/**
 * [实时监听state值的变化(最新状态)]
 * 方法名随意,主要是用来承载变化的值
 * @type {Object}
 */
const getters = {
    getUserName: state => {
      return state.username;
    },
    getUserId: state => {
        return state.userid;
    },
    getUserType: state => {
        return state.usertype;
    },
    getLastloginTime: state => {
        return state.lastlogin_time;
    },
    getPermissionList: state => {
        return state.permission_list;
    },
    getGradeList: state => {
        return state.grade_list;
    },
    getSchoolName: state => {
        return state.school_name;
    },
    getLogo: state => {
        return state.logo;
    },
    getBanner: state => {
        return state.banner;
    },
};

/**
 * [同步修改]
 * 自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象)
 * @type {Object}
 */
const mutations = {
    setUserName(state,newValue){
        // Vue.set(state,'username',newValue);
        state.username = newValue;
    },
    setUserId(state,newValue){
        state.userid = newValue;
    },
    setUserType(state,newValue){
        state.usertype = newValue;
    },
    setLastloginTime(state,newValue){
        state.lastlogin_time = newValue;
    },
    setPermissionList(state,newValue){
        state.permission_list = newValue;
    },
    setGradeList(state,newValue){
        state.grade_list = [].concat(newValue);
    },
    setSchoolName(state,newValue){
        state.school_name = newValue;
    },
    setLogo(state,newValue){
        state.logo = newValue;
    },
    setBanner(state,newValue){
        state.banner = newValue;
    },
};

/**
 * [异步修改]
 * 自定义触发mutations里函数的方法，context与store 实例具有相同方法和属性，num为要变化的形参
 * @type {Object}
 */
const actions = {
    setUserNameAsy(context,newValue){
        context.commit('setUserName',newValue);
    },
    setUserIdAsy(context,newValue){
        context.commit('setUserId',newValue);
    },
    setUserTypeAsy(context,newValue){
        context.commit('setUserType',newValue);
    },
    setLastloginTimeAsy(context,newValue){
        context.commit('setLastloginTime',newValue);
    },
    setPermissionListAsy(context,newValue){
        context.commit('setPermissionList',newValue);
    },
    setGradeListAsy(context,newValue){
        context.commit('setGradeList',newValue);
    },
    setSchoolNameAsy(context,newValue){
        context.commit('setSchoolName',newValue);
    },
    setLogoAsy(context,newValue){
        context.commit('setLogo',newValue);
    },
    setBannerAsy(context,newValue){
        context.commit('setBanner',newValue);
    },
};

export default {
    namespaced:true,//用于在全局引用此文件里的方法时标识这一个的文件名
    state,
    getters,
    mutations,
    actions
};


// WEBPACK FOOTER //
// ./src/store/modules/userStore.js